import shareHome from "@/assets/share-home.jpg.asset.json";
import shareTeam from "@/assets/share-team.jpg.asset.json";
import shareParticulier from "@/assets/share-particulier.jpg.asset.json";
import shareZakelijk from "@/assets/share-zakelijk.jpg.asset.json";
import shareSenioren from "@/assets/share-senioren.jpg.asset.json";
import shareOntruiming from "@/assets/share-ontruiming.jpg.asset.json";
import shareOpslag from "@/assets/share-opslag.jpg.asset.json";
import shareEvenementen from "@/assets/share-evenementen.jpg.asset.json";
import shareInpakken from "@/assets/share-inpakken.jpg.asset.json";
import shareVerhuislift from "@/assets/share-verhuislift.jpg.asset.json";
import shareDozen from "@/assets/share-dozen.jpg.asset.json";

/**
 * Premium linkvoorbeelden (1200x630) met logo: dit is wat mensen zien
 * als een link van de site in WhatsApp, Facebook of LinkedIn wordt gedeeld.
 */
export const shareImages = {
  home: shareHome.url,
  team: shareTeam.url,
  particulier: shareParticulier.url,
  zakelijk: shareZakelijk.url,
  senioren: shareSenioren.url,
  ontruiming: shareOntruiming.url,
  opslag: shareOpslag.url,
  evenementen: shareEvenementen.url,
  inpakken: shareInpakken.url,
  verhuislift: shareVerhuislift.url,
  dozen: shareDozen.url,
} as const;

export type ShareImageKey = keyof typeof shareImages;

export const defaultShareImage = shareImages.home;

export function shareImage(key?: string) {
  if (!key) return defaultShareImage;
  return shareImages[key as ShareImageKey] ?? defaultShareImage;
}
